












import Vue from 'vue'
import { isMobileOnly } from 'mobile-device-detect'
import SubscribeNotifications from '@/mixins/SubscribeNotifications'
import './KisweNotification.scss'


export default Vue.extend({
  name: 'KisweNotification',
  mixins: [ SubscribeNotifications ],
  props: {
    content: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    isMobileOnly (): boolean {
      return isMobileOnly
    },
    paragraph (): string|null {
      if (this.content) return this.content
      // @ts-ignore
      if (this.notifications?.eventlist) return this.notifications?.eventlist.content
      return null
    }
  }
})
